module.exports = __webpack_public_path__ + "static/blacklightlogo-bfb3477a1ecddcb96a84aaf9c113dab0.png";